import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const Arrow = (props: SvgProps) => (
  <Svg width={48} height={36} viewBox="0 0 48 36" fill="none" {...props}>
    <path
      d="M2.28076 18.7463L45.7194 18.9696M45.7194 18.9696C40.731 17.9998 33.0566 11.9386 28.9958 2.2041M45.7194 18.9696C40.731 20.0202 33.0566 26.0814 28.9958 33.7958"
      stroke="url(#paint0_linear_13719_107046)"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_13719_107046"
        x1="37.5"
        y1="18"
        x2="2.28076"
        y2="18"
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset="1" stopColor="#EF196E" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Arrow;
